import React, {
  useEffect,
  useState,
  useLayoutEffect,
  useRef,
} from "react";
import "./App.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register ScrollTrigger plugin with GSAP
gsap.registerPlugin(ScrollTrigger);

export default function App() {
  const [windowSize, setWindowSize] = useState(window.innerWidth > 991);
  const component = useRef();
  const slider = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      setWindowSize(window.innerWidth > 991);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     console.log(window.scrollX);
  //     console.log(window.scrollY);
  //   };

  //   // Attach the scroll event listener
  //   window.addEventListener("scroll", handleScroll);

  //   // Cleanup the event listener when the component is unmounted
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  useLayoutEffect(() => {
    if (windowSize) {
      let ctx = gsap.context(() => {
        let wrapper = document.querySelector(".panels-wrapper");
        let panels = gsap.utils.toArray(".panel");

          // Calculate the width of all panels combined
          const totalWidth = 7300

          // Set wrapper width dynamically
          wrapper.style.width = `${totalWidth}px`;
        gsap.to(wrapper, {
          xPercent: -20 * (panels.length - 1),
          ease: "none",
          scrollTrigger: {
            trigger: slider.current,
            pin: true,
            scrub: 5,
            snap: false,
            end: () => "+=" + slider.current.offsetWidth,
            markers: false,
          },
        });
        const text_1 = document.querySelector("#panel-2-headline");

        // Set initial opacity to 0 when the page loads
        gsap.set(text_1, { opacity: 0 });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: "#panel-2", // The panel triggering the animation
            start: "top bottom", // When the top of #panel-2 reaches the bottom of the viewport
            end: "bottom top", // When the bottom of #panel-2 reaches the top of the viewport
            scrub: true, // Scrub the animation to follow the scroll progress
            onUpdate: function (self) {
              // Gradual opacity change based on scroll position.
              // The opacity will move between 0 (top) and 1 (scroll down).
              const opacityValue =
                window.scrollY === 0 ? 0 : Math.min(window.scrollY / 100, 1); // Limits opacity to 1
              gsap.to(text_1, { opacity: opacityValue, duration: 2 });
            },
          },
        });

        tl.fromTo(text_1, { opacity: 0 }, { opacity: 1 });

        const card1 = document.querySelector("#card-stories-1");
        const container = document.querySelector("#panel-2");

        const containerRect = container.getBoundingClientRect();
        const containerHeight = containerRect.height;

     
        const startY = containerHeight + 3000;

        const t1 = gsap.timeline({
          scrollTrigger: {
            trigger: "#panel-2",
            start: 50,
            end: 1,
            scrub: 3,
            markers: false,
          },
        });

        t1.fromTo(
          card1,
          {
            opacity: 0.3,
            x: 2000,
            y: startY,
          },
          {
            opacity: 1,
            x: 0,
            y: 0,
            ease: "power2.out",
            duration: 5,
          }
        );

        const card2 = document.querySelector("#card-stories-2");
        const t2 = gsap.timeline({
          scrollTrigger: {
            trigger: "#panel-2",
            start: 200,
            end: 1,
            scrub: 3,
            markers: false,
          },
        });

        t2.fromTo(
          card2,
          {
            opacity: 0.3,
            x: 2000,
            y: startY,
          },
          {
            opacity: 1,
            x: 0,
            y: 0,
            ease: "power2.out",
            duration: 5,
          }
        );

        const Featured1 = document.querySelector("#card-Featured-1");
        const container3 = document.querySelector("#panel-3");

        const t3 = gsap.timeline({
          scrollTrigger: {
            trigger: container3,
            start: 350,
            end: 1,
            scrub: 3,
            markers: false,
          },
        });

        t3.fromTo(
          Featured1,
          {
            opacity: 0.3,
            x: 2000,
            y: startY,
          },
          {
            opacity: 1,
            x: 0,
            y: 0,
            ease: "power2.out",
            duration: 5,
          }
        );

        const Featured2 = document.querySelector("#card-Featured-2");

        const t4 = gsap.timeline({
          scrollTrigger: {
            trigger: container3,
            start: 450,
            end: 1,
            scrub: 3,
            markers: false,
          },
        });

        t4.fromTo(
          Featured2,
          {
            opacity: 0.3,
            x: 2000,
            y: startY,
          },
          {
            opacity: 1,
            x: 0,
            y: 0,
            ease: "power2.out",
            duration: 5,
          }
        );


        const Featured3 = document.querySelector("#card-Featured-3");

        const t5 = gsap.timeline({
          scrollTrigger: {
            trigger: container3,                
            start: 550,
            end: 1,
            scrub: 3,
            markers: false,
          }
        });
       
        t5.fromTo(Featured3, 
          { 
            opacity:0.3,
            x: 2000,
            y: startY 
          },
          {
            opacity:1,
            x: 0,
            y: 0,
            ease: "power2.out",
            duration:5
          }
        );


        const Featured4 = document.querySelector("#card-Featured-4");

        const t6 = gsap.timeline({
          scrollTrigger: {
            trigger: container3,                
            start: 600,
            end: 1,
            scrub: 3,
            markers: false,
          }
        });
       
        t6.fromTo(Featured4, 
          { 
            opacity:0.3,
            x: 2000,
            y: startY 
          },
          {
            opacity:1,
            x: 0,
            y: 0,
            ease: "power2.out",
            duration:5
          }
        );


        const container4 = document.querySelector("#panel-4");

        const t7 = gsap.timeline({
          scrollTrigger: {
            trigger: container4,                
            start: 650,
            end: 1,
            scrub: 3,
            markers: false,
          }
        });
       
        t7.fromTo(container4, 
          { 
            opacity:0.3,
            x: 0,
            y: "-100%"
          },
          {
            opacity:1,
            x: 0,
            y: 0,
            ease: "power2.out",
            duration:5
          }
        );


        const leftcontentcontainer = document.querySelector("#left-content-container");

        const t8 = gsap.timeline({
          scrollTrigger: {
            trigger: container4,                
            start: 700,
            end: 1,
            scrub: 3,
            markers: false,
          }
        });
       
        t8.fromTo(leftcontentcontainer, 
          { 
            opacity:0,
            x: 0,
            y: 2000
          },
          {
            opacity:1,
            x: 0,
            y: 0,
            ease: "power2.out",
            duration:5
          }
        );

        const rightcontentcontainer = document.querySelector("#right-content-container");

        const t9 = gsap.timeline({
          scrollTrigger: {
            trigger: container4,                
            start: 750,
            end: 1,
            scrub: 3,
            markers: false,
          }
        });
       
        t9.fromTo(rightcontentcontainer, 
          { 
            opacity:0,
            x: 0,
            y: 2000
          },
          {
            opacity:1,
            x: 0,
            y: 0,
            ease: "power2.out",
            duration:5
          }
        );
        const container5 = document.querySelector("#panel-5");

        const leftcornermedia = document.querySelector("#left-corner-media");

        const t10 = gsap.timeline({
          scrollTrigger: {
            trigger: container5,                
            start: 850,
            end: 1,
            scrub: 3,
            markers: false,
          }
        });
       
        t10.fromTo(leftcornermedia, 
          { 
            opacity:0,
            x: 0,
            y: 2000
          },
          {
            opacity:1,
            x: 0,
            y: 0,
            ease: "power2.out",
            duration:5
          }
        );


        const headingcontainer = document.querySelector("#heading-container");

        const t11 = gsap.timeline({
          scrollTrigger: {
            trigger: container5,                
            start: 950,
            end: 1,
            scrub: 3,
            markers: false,
          }
        });
       
        t11.fromTo(headingcontainer, 
          { 
            opacity:0,
            x: 0,
            y: 2000
          },
          {
            opacity:1,
            x: 0,
            y: 0,
            ease: "power2.out",
            duration:5
          }
        );


        const centercontentcontainer = document.querySelector("#center-content-container");

        const t12 = gsap.timeline({
          scrollTrigger: {
            trigger: container5,                
            start: 1000,
            end: 1,
            scrub: 3,
            markers: false,
          }
        });
       
        t12.fromTo(centercontentcontainer, 
          { 
            opacity:0,
            x: 0,
            y: 2000
          },
          {
            opacity:1,
            x: 0,
            y: 0,
            ease: "power2.out",
            duration:5
          }
        );
        

      }, component);
      return () => ctx.revert();
    }
  });

  // useLayoutEffect(() => {
  //   let ctx = gsap.context(() => {
  //     let wrapper = document.querySelector(".panels-wrapper");
  //     let panels = gsap.utils.toArray(".panel");
  //     gsap.to(wrapper, {
  //       xPercent: -20 * (panels.length - 1),
  //       ease: "none",
  //       scrollTrigger: {
  //         trigger: slider.current,
  //         pin: true,
  //         scrub: 6,
  //         snap: false,
  //         end: () => "+=" + slider.current.offsetWidth,
  //         markers: false
  //       }
  //     });

  //   }, component);
  //   return () => ctx.revert();
  // });

  return (
    <div
      id="app"
      class={`sticky-footer__wrapper--c683bb47 scroll-container ${
        windowSize ? "desktop-scroll" : "mobile-scroll"
      }`}
      ref={component}
    >
      <div class="sticky-footer__content--fdfeee14 ">
        <main role="main">
          <header class="w-100 top-0 styles__container--f5caf644">
            <div class="container mx-auto styles__centerColumnContainer--ff939d9c styles__padded--a8319bed py-4">
              <div id="header-scroll-lock" class="color-red">
                <div class="d-flex justify-content-between">
                  <a
                    href="/"
                    class="position-relative"
                  >
                    <img src="/assets/logo-lawyer.png" alt="Logo" className="logo" />
                    <span class="u-visually-hidden">Lawyer</span>
                  </a>
                  <div class="d-flex">
                    <ul class="d-md-flex align-items-center d-none">
                      <li class="ms-3 js-nav-text-color">
                        <a
                          href="/"
                          class="text-decoration-underline-hover text-decoration-underline-hover styles__link--cdf31134 type__h8 text-decoration-none-hover"
                        >
                          Professionals
                        </a>
                      </li>
                      <li class="ms-3 js-nav-text-color">
                        <a
                          href="/"
                          class="text-decoration-underline-hover text-decoration-underline-hover styles__link--cdf31134 type__h8 text-decoration-none-hover"
                        >
                          Experience
                        </a>
                      </li>
                      <li class="ms-3 js-nav-text-color">
                        <a
                           href="/"
                          class="text-decoration-underline-hover text-decoration-underline-hover styles__link--cdf31134 type__h8 text-decoration-none-hover"
                        >
                          Insights
                        </a>
                      </li>
                    </ul>
                    <div class="d-flex align-items-center ms-3">
                      <button type="button" aria-label="Menu">
                        <span class="u-hide-in-print styles__icon--ca0ac637 styles__type__icon--c894d027 js-nav-text-color">
                          <span class="icon-menu" aria-hidden="true"></span>
                          <span class="u-visually-hidden">Menu</span>
                        </span>
                      </button>
                      <button type="button" class="ms-3" aria-label="Search">
                        <span class="u-hide-in-print styles__icon--ca0ac637 styles__type__icon--c894d027 js-nav-text-color">
                          <span class="icon-search" aria-hidden="true"></span>
                          <span class="u-visually-hidden">Search</span>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <div
            id="homepage-horizontal-scroll-container "
            class="d-flex flex-column flex-lg-row w-100"
            ref={slider}
          >
            <div class={`${windowSize ? "panels-wrapper d-flex" : ""}`}>
              <h1 class="d-none">Homepage</h1>
              <div class="d-lg-flex align-items-lg-stretch panel js-panel js-panel-dark">
                <div id="panel-1" class="position-relative">
                  <div class="styles__video--ef30c62d position-relative">
                  <img
                src="/assets/0.jpg"
                alt="0"
                class="d-block w-100 h-100 styles__video--b1957c4c"
              />
                    <div class="position-absolute top-0 bottom-0 start-0 end-0 rs-bg-transparent-black"></div>
                  </div>
                  <div class="container mx-auto styles__centerColumnContainer--ff939d9c styles__padded--a8319bed h-100 d-flex flex-column justify-content-end position-absolute start-0 end-0 top-0 bottom-0 styles__contentOverlayContainer--cb331119">
                    <div class="styles__contentContainer--e950c0d5">
                      <p class="color-gold-yellow styles__type__heading--f9d62a05 d-block mb-3 rte">
                      Creative Law Firm for Legal Problems
                      </p>
                      <p class="color-white styles__type__description--c255f52d rte">
                      Welcome to Premier Law Firm Consultancy, where legal excellence
              meets strategic guidance. We are a leading consultancy firm
              dedicated to providing unparalleled legal advice and solutions to
              businesses, organizations, and individuals. With our team of
              seasoned legal experts, we navigate complex legal landscapes,
              ensuring our clients' interests are protected.
                      </p>
                      <form
                        role="search"
                        action="/"
                      >
                        <label class="d-none" for="homepage-video-panel-search">
                          Search
                        </label>
                        <div class="styles__searchInputContainer--d1fbc62a d-flex justify-content-between mt-5">
                          <input
                            autocomplete="chrome-off"
                            class="styles__searchInput--db10bb72 color-white ps-3 styles__type__searchInput--afc0d372 mx-auto"
                            id="homepage-video-panel-search"
                            name="q"
                            placeholder="How can we help you?"
                            value=""
                          />
                          <button
                            class="styles__searchButton--f0806c64"
                            type="submit"
                          >
                            <span class="u-hide-in-print styles__icon--ca0ac637 color-white styles__searchIcon--f3c703c0 pe-3 py-2">
                              <span
                                class="icon-search"
                                aria-hidden="true"
                              ></span>
                              <span class="u-visually-hidden">Search</span>
                            </span>
                          </button>
                        </div>
                      </form>
                    </div>
                    <div class="d-flex justify-content-center d-lg-none pt-4">
                      <button
                        type="button"
                        class="u-hide-in-print styles__icon--ca0ac637 color-turquoise-blue styles__scrollDownArrow--e19ff951 styles__bounce2--e270c01b"
                        aria-label="Scroll Down"
                      >
                        <span
                          class="icon-arrow-right"
                          aria-hidden="true"
                        ></span>
                        <span class="u-visually-hidden">Scroll Down</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-lg-flex align-items-lg-stretch panel js-panel">
                <div
                  class="container mx-auto styles__centerColumnContainer--ff939d9c styles__padded--a8319bed d-flex w-100 flex-column justify-content-center mt-5 mt-lg-0 pt-5 pt-lg-5 styles__panelContainer--e6e6294d"
                  id="panel-2"
                >
                  <div class="position-relative">
                    <p
                      id="panel-2-headline"
                      class="position-absolute top-0 start-0 styles__type__headline--a52ca0c8 color-navy-blue styles__headline--c3245d19"
                    >
                   Latest News Update
                    </p>
                    <div class="d-flex flex-column flex-lg-row styles__cardsContainer--c0210483">
                      <div class="mx-lg-4 panel-2-card" id="card-stories-1">
                        <div class="d-flex flex-column styles__cardContainer--c5471b61">
                          <a
                            class="color-navy-blue d-inline-block"
                            href="/en/success-stories/navigating-rapid-and-necessary-exits-from-russia"
                          >
                            <div class="styles__borderLine--ef53d48c">
                              <picture>
                                <source  srcset="/assets/1.jpg"/>
                                <img
                                  alt=""
                                  style={{ borderRadius: "0px 150px 0px 0px" }}
                                  height="320"
                                  src="/assets/1.jpg"
                                  width="480"
                                  class="d-block styles__asset--b82cbb90 pb-4 styles__media--c42d4881 w-100"
                                />
                              </picture>
                            </div>
                            <p class="mt-3">
                              <span class="styles__type__cardHeading--de7b29cc rte">
                                {" "}
                                Journalists devoted to coverage of the Supreme Court
                              </span>
                            </p>
                          </a>
                          <div class="d-inline-block d-lg-none my-4">
                            <p class="d-print-none">
                              <a
                                class=""
                                href="/en/success-stories/navigating-rapid-and-necessary-exits-from-russia"
                              >
                                <span class="styles__labelContainer--c5a57a25 styles__solid--c603185c">
                                  <span class="styles__text--e36ff6ce">
                                    Read More
                                  </span>
                                  <span class="u-hide-in-print styles__icon--ca0ac637 ms-2 styles__icon--c4ed4929 color-turquoise-blue">
                                    <span
                                      class="icon-arrow-right"
                                      aria-hidden="true"
                                    ></span>
                                    <span class="u-visually-hidden"></span>
                                  </span>
                                </span>
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="mx-lg-4 panel-2-card" id="card-stories-2">
                        <div class="d-flex flex-column styles__cardContainer--c5471b61">
                          <a
                            class="color-navy-blue d-inline-block"
                            href="/en/success-stories/a-cross-border-defense-of-quality-dana-uk-axle"
                          >
                            <div class="styles__borderLine--ef53d48c">
                              <picture>
                                <source srcset="/assets/2.jpg" />
                                <img
                                  alt=""
                                  style={{ borderRadius: "0px 0px 0px 150px" }}
                                  height="320"
                                  src="/assets/2.jpg"
                                  width="480"
                                  class="d-block styles__asset--b82cbb90 pb-4 styles__media--c42d4881 w-100"
                                />
                              </picture>
                            </div>
                            <p class="mt-3">
                              <span class="styles__type__cardHeading--de7b29cc rte">
                              Our team comprises highly skilled attorneys
                              </span>
                            </p>
                          </a>
                          <div class="d-inline-block d-lg-none my-4">
                            <p class="d-print-none">
                              <a
                                class=""
                                href="/en/success-stories/a-cross-border-defense-of-quality-dana-uk-axle"
                              >
                                <span class="styles__labelContainer--c5a57a25 styles__solid--c603185c">
                                  <span class="styles__text--e36ff6ce">
                                    Read More
                                  </span>
                                  <span class="u-hide-in-print styles__icon--ca0ac637 ms-2 styles__icon--c4ed4929 color-turquoise-blue">
                                    <span
                                      class="icon-arrow-right"
                                      aria-hidden="true"
                                    ></span>
                                    <span class="u-visually-hidden"></span>
                                  </span>
                                </span>
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-lg-flex align-items-lg-stretch panel js-panel">
                <div
                  class="container mx-auto styles__centerColumnContainer--ff939d9c d-lg-flex justify-content-lg-center flex-lg-column styles__panelContainer--b7b78a29"
                  id="panel-3"
                >
                  <div>
                    <div class="container mx-auto styles__centerColumnContainer--ff939d9c styles__padded--a8319bed styles__headingContainer--fa3b0671">
                      <p
                        id="panel-3-headline"
                        class="color-navy-blue styles__type__heading--c569e3d8 styles__borderLine--f156bbda py-lg-4 text-lg-end"
                      >
                        Meet Our Experts
                      </p>
                    </div>
                    <div class="container mx-auto styles__centerColumnContainer--ff939d9c styles__padded--a8319bed d-flex flex-column flex-lg-row styles__cardsContainer--e5045d7d">
                      <div
                        class="panel-3-card styles__cardWrapper--c04183ab"
                        id="card-Featured-1"
                      >
                        <a
                          class="d-none d-lg-block"
                           href="/"
                        >
                          <picture>
                            <source srcset="/assets/experts/expert-1.jpg" />
                            <img
                              alt=""
                              height="321"
                              src="/assets/experts/expert-1.jpg"
                              width="480"
                              class="d-block styles__asset--b82cbb90 styles__media--a1f3f88a w-100"
                            />
                          </picture>
                        </a>
                        <div class="d-flex flex-column flex-lg-row py-4">
                          <div class="h-100 styles__bestPracticesCardContainer--c06e5a5e">
                            <div>
                              <p class="color-navy-blue pb-2">
                                <span class="styles__type__eyebrow-bolded--f58ad6cf styles__type__eyebrow--f7e2d8b9">
                                Firm News
                                </span>
                                <span class="mx-1 color-gold-yellow styles__type__separator--d972929c">
                                  {" "}
                                  |{" "}
                                </span>
                                <span class="styles__type__eyebrow--f7e2d8b9">
                                  1 min read
                                </span>
                                <span class="mx-1 color-gold-yellow styles__type__separator--d972929c">
                                  {" "}
                                  |{" "}
                                </span>
                                <span class="styles__type__eyebrow--f7e2d8b9">
                                07.13.23
                                </span>
                              </p>
                              <p class="styles__underlineLinkOnHover--d6fe1e30 styles__type__heading--d6b21462 styles__boldHeading--e88d5b39 color-navy-blue pe-4">
                                <a
                                   href="/"
                                  class="text-decoration-underline-hover text-decoration-underline-hover"
                                >
                                  <span class="rte">
                                  Anne Li an Emerging Divorce Lawyer
                                  </span>
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="panel-3-card styles__cardWrapper--c04183ab"
                        id="card-Featured-2"
                      >
                        <a
                          class="d-none d-lg-block"
                           href="/"
                        >
                          <picture>
                            <source srcset="/assets/experts/expert-2.jpg" />
                            <img
                              alt=""
                              height="251"
                              src="/assets/experts/expert-2.jpg"
                              width="480"
                              class="d-block styles__asset--b82cbb90 styles__media--a1f3f88a w-100"
                            />
                          </picture>
                        </a>
                        <div class="d-flex flex-column flex-lg-row py-4">
                          <div class="h-100 styles__bestPracticesCardContainer--c06e5a5e">
                            <div>
                              <p class="color-navy-blue pb-2">
                                <span class="styles__type__eyebrow-bolded--f58ad6cf styles__type__eyebrow--f7e2d8b9">
                                  Firm News
                                </span>
                                <span class="mx-1 color-gold-yellow styles__type__separator--d972929c">
                                  {" "}
                                  |{" "}
                                </span>
                                <span class="styles__type__eyebrow--f7e2d8b9">
                                  1 min read
                                </span>
                                <span class="mx-1 color-gold-yellow styles__type__separator--d972929c">
                                  {" "}
                                  |{" "}
                                </span>
                                <span class="styles__type__eyebrow--f7e2d8b9">
                                07.13.23
                                </span>
                              </p>
                              <p class="styles__underlineLinkOnHover--d6fe1e30 styles__type__heading--d6b21462 styles__boldHeading--e88d5b39 color-navy-blue pe-4">
                                <a
                                  href="/"
                                  class="text-decoration-underline-hover text-decoration-underline-hover"
                                >
                                  <span class="rte">
                               The National Law Journal Names S.Starling Marshall Family Lawyer
                                  </span>
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="panel-3-card styles__cardWrapper--c04183ab"
                        id="card-Featured-3"
                      >
                        <a
                          class="d-none d-lg-block"
                           href="/"
                        >
                          <picture>
                            <source srcset="/assets/experts/expert-3.jpg" />
                            <img
                              alt=""
                              height="350"
                              src="/assets/experts/expert-3.jpg"
                              width="480"
                              class="d-block styles__asset--b82cbb90 styles__media--a1f3f88a w-100"
                            />
                          </picture>
                        </a>
                        <div class="d-flex flex-column flex-lg-row py-4">
                          <div class="h-100 styles__bestPracticesCardContainer--c06e5a5e">
                            <div>
                              <p class="color-navy-blue pb-2">
                                <span class="styles__type__eyebrow-bolded--f58ad6cf styles__type__eyebrow--f7e2d8b9">
                                  Firm News
                                </span>
                                <span class="mx-1 color-gold-yellow styles__type__separator--d972929c">
                                  {" "}
                                  |{" "}
                                </span>
                                <span class="styles__type__eyebrow--f7e2d8b9">
                                  2 min read
                                </span>
                                <span class="mx-1 color-gold-yellow styles__type__separator--d972929c">
                                  {" "}
                                  |{" "}
                                </span>
                                <span class="styles__type__eyebrow--f7e2d8b9">
                                07.13.23
                                </span>
                              </p>
                              <p class="styles__underlineLinkOnHover--d6fe1e30 styles__type__heading--d6b21462 styles__boldHeading--e88d5b39 color-navy-blue pe-4">
                                <a
                                   href="/"
                                  class="text-decoration-underline-hover text-decoration-underline-hover"
                                >
                                  <span class="rte">
                                  Jacob Jones Criminal Lawyer
                                  </span>
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="panel-3-card styles__cardWrapper--c04183ab"
                        id="card-Featured-4"
                      >
                        <a
                          class="d-none d-lg-block"
                           href="/"
                        >
                          <picture>
                            <source srcset="/assets/experts/expert-4.jpg" />
                            <img
                              alt=""
                              height="320"
                              src="/assets/experts/expert-4.jpg"
                              width="480"
                              class="d-block styles__asset--b82cbb90 styles__media--a1f3f88a w-100"
                            />
                          </picture>
                        </a>
                        <div class="d-flex flex-column flex-lg-row py-4">
                          <div class="h-100 styles__bestPracticesCardContainer--c06e5a5e">
                            <div>
                              <p class="color-navy-blue pb-2">
                                <span class="styles__type__eyebrow-bolded--f58ad6cf styles__type__eyebrow--f7e2d8b9">
                                Firm News
                                </span>
                                <span class="mx-1 color-gold-yellow styles__type__separator--d972929c">
                                  {" "}
                                  |{" "}
                                </span>
                                <span class="styles__type__eyebrow--f7e2d8b9">
                                  2 min read
                                </span>
                                <span class="mx-1 color-gold-yellow styles__type__separator--d972929c">
                                  {" "}
                                  |{" "}
                                </span>
                                <span class="styles__type__eyebrow--f7e2d8b9">
                                07.13.23
                                </span>
                              </p>
                              <p class="styles__underlineLinkOnHover--d6fe1e30 styles__type__heading--d6b21462 styles__boldHeading--e88d5b39 color-navy-blue pe-4">
                                <a
                                  href="/"
                                  class="text-decoration-underline-hover text-decoration-underline-hover"
                                >
                                  <span class="rte">
                                  William Gates Real Estate Lawyer
                                  </span>
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-lg-flex align-items-lg-stretch panel js-panel js-panel-dark">
                <div
                  class="container mx-auto styles__centerColumnContainer--ff939d9c styles__panelContainer--ebea9a96 rs-bg-chartreuse-green d-lg-flex justify-content-lg-center flex-lg-column h-100 position-relative"
                  id="panel-4"
                >
                  <div class="container mx-auto styles__centerColumnContainer--ff939d9c styles__padded--a8319bed styles__innerContainer--e5c52001 d-lg-flex flex-lg-row justify-content-between">
                    <div
                      id="left-content-container"
                      class="styles__contentContainer--e6197286 pt-3 pb-5 me-lg-5"
                    >
                      <p class="styles__type__heading--a7cd674b color-navy-blue">
                      Our Services & Your Trusted Legal Advisors
                      </p>
                      <p class="styles__type__description--b0225b61 color-white mt-3">
                        <span class="rte">
                        At Premier Law Firm Consultancy, we pride ourselves on our reputation as a dynamic and client-focused legal consultancy firm. Our team comprises highly skilled attorneys, consultants, and experts with extensive experience across diverse legal fields. From corporate law and intellectual property to regulatory compliance and dispute resolution
                        </span>
                      </p>
                      <div class="d-none d-lg-inline-block mt-5">
                        <p class="d-print-none">
                          <a class="" href="/en/insights">
                            <span class="styles__labelContainer--c5a57a25 styles__transparent--ca1d68ba">
                              <span class="styles__text--e36ff6ce">
                                View All Insights
                              </span>
                              <span class="u-hide-in-print styles__icon--ca0ac637 ms-2 styles__icon--c4ed4929 color-gold-yellow">
                                <span
                                  class="icon-arrow-right"
                                  aria-hidden="true"
                                ></span>
                                <span class="u-visually-hidden"></span>
                              </span>
                            </span>
                          </a>
                        </p>
                      </div>
                    </div>

                    <div
                      id="right-content-container"
                      class="styles__listingsContainer--f0a03d56"
                    >
                      <ul>
                        <li class="styles__listingContainer--e539aba0">
                          <a
                            class="d-flex justify-content-between pt-3 pb-4"
                            href="/"
                          >
                            <p class="color-white styles__listingName--a6ea836b styles__type__listingName--eaaaa7e4 pe-3">
                              <span class="rte">
                             1. Corporate Law: Our corporate lawyers provide comprehensive legal support to businesses at every stage of their growth
                              </span>
                            </p>
                            <span class="u-hide-in-print styles__icon--ca0ac637 color-white styles__listingIcon--c5d73829 d-flex justify-content-end align-items-center">
                              <span
                                class="icon-arrow-right-long"
                                aria-hidden="true"
                              ></span>
                              <span class="u-visually-hidden"></span>
                            </span>
                          </a>
                        </li>
                        <li class="styles__listingContainer--e539aba0">
                          <a
                            class="d-flex justify-content-between pt-3 pb-4"
                             href="/"
                          >
                            <p class="color-white styles__listingName--a6ea836b styles__type__listingName--eaaaa7e4 pe-3">
                              <span class="rte">
                              2. Intellectual Property: Our experts safeguard your innovations and creations through patent, trademark, and copyright protection

                              </span>
                            </p>
                            <span class="u-hide-in-print styles__icon--ca0ac637 color-white styles__listingIcon--c5d73829 d-flex justify-content-end align-items-center">
                              <span
                                class="icon-arrow-right-long"
                                aria-hidden="true"
                              ></span>
                              <span class="u-visually-hidden"></span>
                            </span>
                          </a>
                        </li>
                        <li class="styles__listingContainer--e539aba0">
                          <a
                            class="d-flex justify-content-between pt-3 pb-4"
                            href="/"
                          >
                            <p class="color-white styles__listingName--a6ea836b styles__type__listingName--eaaaa7e4 pe-3">
                              <span class="rte">
                             3. Regulatory Compliance: We help businesses navigate complex regulatory frameworks, ensuring compliance with all applicable

                              </span>
                            </p>
                            <span class="u-hide-in-print styles__icon--ca0ac637 color-white styles__listingIcon--c5d73829 d-flex justify-content-end align-items-center">
                              <span
                                class="icon-arrow-right-long"
                                aria-hidden="true"
                              ></span>
                              <span class="u-visually-hidden"></span>
                            </span>
                          </a>
                        </li>
                        <li class="styles__listingContainer--e539aba0">
                          <a
                            class="d-flex justify-content-between pt-3 pb-4"
                             href="/"
                          >
                            <p class="color-white styles__listingName--a6ea836b styles__type__listingName--eaaaa7e4 pe-3">
                              <span class="rte">
                             4. Dispute Resolution: When legal disputes arise, our skilled litigators work diligently to resolve conflicts through negotiation, mediation, arbitration, or aggressive representation in court

                              </span>
                            </p>
                            <span class="u-hide-in-print styles__icon--ca0ac637 color-white styles__listingIcon--c5d73829 d-flex justify-content-end align-items-center">
                              <span
                                class="icon-arrow-right-long"
                                aria-hidden="true"
                              ></span>
                              <span class="u-visually-hidden"></span>
                            </span>
                          </a>
                        </li>
                        <li class="styles__listingContainer--e539aba0">
                          <a
                            class="d-flex justify-content-between pt-3 pb-4"
                             href="/"
                          >
                            <p class="color-white styles__listingName--a6ea836b styles__type__listingName--eaaaa7e4 pe-3">
                              <span class="rte">
                            5.  Employment Law: Our consultants offer practical guidance on employment matters, including contracts, workplace policies

                              </span>
                            </p>
                            <span class="u-hide-in-print styles__icon--ca0ac637 color-white styles__listingIcon--c5d73829 d-flex justify-content-end align-items-center">
                              <span
                                class="icon-arrow-right-long"
                                aria-hidden="true"
                              ></span>
                              <span class="u-visually-hidden"></span>
                            </span>
                          </a>
                        </li>
                        <li class="styles__listingContainer--e539aba0">
                          <a
                            class="d-flex justify-content-between pt-3 pb-4"
                             href="/"
                          >
                            <p class="color-white styles__listingName--a6ea836b styles__type__listingName--eaaaa7e4 pe-3">
                              <span class="rte">
                             6. Confidentiality and Ethics
    
                              </span>
                            </p>
                            <span class="u-hide-in-print styles__icon--ca0ac637 color-white styles__listingIcon--c5d73829 d-flex justify-content-end align-items-center">
                              <span
                                class="icon-arrow-right-long"
                                aria-hidden="true"
                              ></span>
                              <span class="u-visually-hidden"></span>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class="d-inline-block d-lg-none mt-5">
                      <p class="d-print-none">
                        <a class="" href="/en/insights">
                          <span class="styles__labelContainer--c5a57a25 styles__solid--c603185c">
                            <span class="styles__text--e36ff6ce">
                              View All Insights
                            </span>
                            <span class="u-hide-in-print styles__icon--ca0ac637 ms-2 styles__icon--c4ed4929 color-turquoise-blue">
                              <span
                                class="icon-arrow-right"
                                aria-hidden="true"
                              ></span>
                              <span class="u-visually-hidden"></span>
                            </span>
                          </span>
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-lg-flex align-items-lg-stretch panel js-panel js-panel-dark">
                <div
                  id="panel-5"
                  class="rs-bg-grape-purple styles__panelContainer--eef6b700 position-relative h-100 d-lg-flex justify-content-lg-center flex-lg-column"
                >
                  <div
                    id="left-corner-media"
                    class="d-none d-lg-block position-absolute start-0 bottom-0"
                  >
                    <picture>
                      <source
                        srcset="/assets/3.jpg"
                        media="(min-width: 1024px)"
                      />
                      <source srcset="/assets/3.jpg" />
                      <img
                        alt=""
                        height="1571"
                        src="/assets/3.jpg"
                        width="1000"
                        class="d-block styles__leftCornerMedia--e8b2c6a5"
                      />
                    </picture>
                  </div>
                  <div class="container mx-auto styles__centerColumnContainer--ff939d9c styles__padded--a8319bed d-flex flex-column flex-lg-row pt-5 justify-content-lg-start styles__contentContainer--adb5d02f">
                    <div
                      id="heading-container"
                      class="styles__headingContainer--c1f7250e w-100 d-flex flex-column justify-content-lg-center"
                    >
                      <p class="styles__type__heading--cf2f251a color-white py-4">
                      Our Portfolio
                      </p>
                      <picture>
                        <source srcset="/assets/4.jpg" />
                        <img
                          alt=""
                          height="342"
                          src="/assets/4.jpg"
                          width="480"
                          class="d-block styles__asset--b82cbb90 styles__media--ef080968"
                        />
                      </picture>
                    </div>
                    <div
                      id="center-content-container"
                      class="color-white d-flex flex-column justify-content-end w-100 order-3 order-lg-2 mb-4"
                    >
                      <p class="styles__type__ctaHeading--d38fb497 mb-4">
                        <span class="rte">
                        We Are Always Ready For A Challenge
                        </span>
                      </p>
                      <p>
                        <span class="rte">
                        At Premier Law firm Consultancy, we pride ourselves on our reputation as a dynamic and client-focused legal consultancy firm. Our team comprises highly skilled attorneys, consultants, and experts with extensive experience across diverse legal fields. From corporate law and intellectual property to regulatory compliance and dispute resolution, our professionals are well0versed in all aspects of the law..
                        </span>
                      </p>
                      <div class="mt-4">
                        <p class="d-print-none">
                          <a class="" href="/en/pro-bono">
                            <span class="styles__labelContainer--c5a57a25 styles__solid--c603185c">
                              <span class="styles__text--e36ff6ce">
                                Learn More
                              </span>
                              <span class="u-hide-in-print styles__icon--ca0ac637 ms-2 styles__icon--c4ed4929">
                                <span
                                  class="icon-arrow-right"
                                  aria-hidden="true"
                                ></span>
                                <span class="u-visually-hidden"></span>
                              </span>
                            </span>
                          </a>
                        </p>
                      </div>
                    </div>
                    <div
                      id="graphics-modules-container"
                      class="d-flex flex-column ms-xxl-5 ms-lg-4 w-100 order-2 order-lg-3"
                    >
                      <a
                        class="styles__graphicsModuleContainer--d9c2b354 py-4"
                        href="/"
                      >
                        <img
                          alt=""
                          height="467"
                          src="/assets/pro-bono-matters.png"
                          width="1190"
                          class="styles__graphicsModuleMedia--b8191ab0 d-block w-100"
                        />
                        <p class="color-white type__body text-center mt-2">
                          <span class="rte">
                            new pro bono matters opened in 2023
                          </span>
                        </p>
                      </a>
                      <a
                        class="styles__graphicsModuleContainer--d9c2b354 py-4"
                        href="/"
                      >
                        <img
                          alt=""
                          height="467"
                          src="/assets/pro-bono-hours.png"
                          width="1115"
                          class="styles__graphicsModuleMedia--b8191ab0 d-block w-100"
                        />
                        <p class="color-white type__body text-center mt-2">
                          <span class="rte">
                            hours of pro bono legal services donated in 2023
                          </span>
                        </p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-lg-flex align-items-lg-stretch panel js-panel js-panel-dark">
                <div
                  class="container mx-auto styles__centerColumnContainer--ff939d9c styles__panelContainer--c1ae4d5a rs-bg-navy-blue d-flex flex-column h-100 color-white justify-content-lg-between"
                  id="panel-6"
                >
                  <div class="d-flex justify-content-start my-5 py-5 my-md-5 my-lg-auto">
                    <img
                      alt=""
                      src="/assets/logo-watermark.png"
                      class="styles__logoWatermark--b406348a"
                      id="logo-watermark"
                    />
                  </div>
                  <div
                    id="links-container"
                    class="d-flex justify-content-between styles__linksContainer--a0425888"
                  >
                    <div class="d-flex flex-column me-5">
                      <p class="styles__type__socialMediaHeading--bafd0eb2">
                        Contact Us
                      </p>
                      <ul class="d-flex my-3">
                        <li>
                          <a
                            href="https://twitter.com/"
                            class="u-hide-in-print styles__icon--ca0ac637 color-white styles__socialMediaIcon--a8d614e1 me-3 styles__animated--c6686a35 d-inline-flex"
                            aria-label="Twitter/X"
                          >
                            <span
                              class="icon-twitter"
                              aria-hidden="true"
                            ></span>
                            <span class="u-visually-hidden">Twitter/X</span>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.youtube.com/channel/UCGXxJbqMOaAs41wdcYy9u3w"
                            class="u-hide-in-print styles__icon--ca0ac637 color-white styles__socialMediaIcon--a8d614e1 me-3 styles__animated--c6686a35 d-inline-flex"
                            aria-label="Youtube"
                          >
                            <span
                              class="icon-youtube"
                              aria-hidden="true"
                            ></span>
                            <span class="u-visually-hidden">Youtube</span>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.linkedin.com/"
                            class="u-hide-in-print styles__icon--ca0ac637 color-white styles__socialMediaIcon--a8d614e1 me-3 styles__animated--c6686a35 d-inline-flex"
                            aria-label="LinkedIn"
                          >
                            <span
                              class="icon-linkedin"
                              aria-hidden="true"
                            ></span>
                            <span class="u-visually-hidden">LinkedIn</span>
                          </a>
                        </li>
                      </ul>
                      <ul class="mb-2 mb-lg-5 pb-lg-5">
                        <li>
                          <a
                            class="type__body mb-1 d-inline-block styles__underlineOnHover--ec405f2e styles__type__link--c109f8a2"
                            href="/en/subscribe"
                          >
                            <p>Subscribe</p>
                          </a>
                        </li>
                        <li>
                          <a
                            class="type__body mb-1 d-inline-block styles__underlineOnHover--ec405f2e styles__type__link--c109f8a2"
                            href="/en/terms-of-use"
                          >
                            <p>Terms of Use</p>
                          </a>
                        </li>
                        <li>
                          <a
                            class="type__body mb-1 d-inline-block styles__underlineOnHover--ec405f2e styles__type__link--c109f8a2"
                            href="/en/privacy-statement"
                          >
                            <p>Privacy Statement</p>
                          </a>
                        </li>
                        <li>
                          <a
                            class="type__body mb-1 d-inline-block styles__underlineOnHover--ec405f2e styles__type__link--c109f8a2"
                            href="/en/awards-methodology"
                          >
                            <p>Awards Methodology</p>
                          </a>
                        </li>
                        <li>
                          <a
                            class="type__body mb-1 d-inline-block styles__underlineOnHover--ec405f2e styles__type__link--c109f8a2"
                            href="/en/legal-notices"
                          >
                            <p>Legal Notices</p>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class="d-flex flex-column w-50">
                      <ul class="mb-2 mb-lg-5 pb-lg-5">
                        <li>
                          <a
                            class="type__body mb-1 d-inline-block styles__underlineOnHover--ec405f2e styles__type__link--c109f8a2"
                            href="/en/professionals"
                          >
                            <p>Professionals</p>
                          </a>
                        </li>
                        <li>
                          <a
                            class="type__body mb-1 d-inline-block styles__underlineOnHover--ec405f2e styles__type__link--c109f8a2"
                            href="/en/services"
                          >
                            <p>Experience</p>
                          </a>
                        </li>
                        <li>
                          <a
                            class="type__body mb-1 d-inline-block styles__underlineOnHover--ec405f2e styles__type__link--c109f8a2"
                            href="/en/insights"
                          >
                            <p>Insights</p>
                          </a>
                        </li>
                        <li>
                          <a
                            class="type__body mb-1 d-inline-block styles__underlineOnHover--ec405f2e styles__type__link--c109f8a2"
                            href="/en/about-us/overview"
                          >
                            <p>About Us</p>
                          </a>
                        </li>
                        <li>
                          <a
                            class="type__body mb-1 d-inline-block styles__underlineOnHover--ec405f2e styles__type__link--c109f8a2"
                            href="/"
                          >
                            <p>Diversity, Equity and Inclusion</p>
                          </a>
                        </li>
                        <li>
                          <a
                            class="type__body mb-1 d-inline-block styles__underlineOnHover--ec405f2e styles__type__link--c109f8a2"
                            href="/en/pro-bono/"
                          >
                            <p>Pro Bono</p>
                          </a>
                        </li>
                        <li>
                          <a
                            class="type__body mb-1 d-inline-block styles__underlineOnHover--ec405f2e styles__type__link--c109f8a2"
                            href="/en/locations"
                          >
                            <p>Locations</p>
                          </a>
                        </li>
                        <li>
                          <a
                            class="type__body mb-1 d-inline-block styles__underlineOnHover--ec405f2e styles__type__link--c109f8a2"
                            href="/en/careers"
                          >
                            <p>Careers</p>
                          </a>
                        </li>
                      </ul>
                      <p class="type__small-body d-none d-lg-block">
                        ©2023 John &amp; Wedemen LLP. All Rights Reserved.
                        Attorney Advertising — Prior results do not guarantee a
                        similar outcome.
                      </p>
                    </div>
                  </div>
                  <div class="d-lg-none mb-5">
                    <p class="type__small-body">
                      <span>
                        {" "}
                        ©2023 John &amp; Wedemen LLP. All Rights Reserved.
                        Attorney Advertising — Prior results do not guarantee a
                        similar outcome.
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div
            id="homepage-scroll-left-button"
            class="d-none position-fixed styles__scrollLeftButton--ae976f70 d-lg-block"
          >
            <p class="d-print-none">
              <button class="" type="button">
                <span class="styles__labelContainer--c5a57a25 styles__solid--c603185c">
                  <span class="u-hide-in-print styles__icon--ca0ac637 me-2 styles__icon--c4ed4929 color-turquoise-blue">
                    <span class="icon-arrow-left" aria-hidden="true"></span>
                    <span class="u-visually-hidden"></span>
                  </span>
                  <span class="styles__text--e36ff6ce">Explore</span>
                </span>
              </button>
            </p>
          </div>
          <div
            id="homepage-scroll-right-button"
            class="d-none position-fixed styles__scrollRightButton--b6b11029 d-lg-block"
          >
            <p class="d-print-none">
              <button class="" type="button">
                <span class="styles__labelContainer--c5a57a25 styles__solid--c603185c">
                  <span class="styles__text--e36ff6ce">Explore</span>
                  <span class="u-hide-in-print styles__icon--ca0ac637 ms-2 styles__icon--c4ed4929 color-turquoise-blue">
                    <span class="icon-arrow-right" aria-hidden="true"></span>
                    <span class="u-visually-hidden"></span>
                  </span>
                </span>
              </button>
            </p>
          </div> */}
        </main>
      </div>
    </div>
  );
}
